import * as React from "react";
import "./CPAppLoaderStyles.scss";
import { Box, CPText, Container } from "../../base";
import { Loader } from "@progress/kendo-react-indicators";

interface CPAppLoaderProps {
  /** When `true`, renders a full-screen branded overlay with a centred spinner. When `false`, renders `null`. */
  isLoading: boolean;
  text?: string;
}

/**
 * Full-screen application loading overlay.
 * Typically used during the initial app bootstrap / auth check.
 *
 * @example
 * ```tsx
 * <CPAppLoader isLoading={isBootstrapping} />
 * ```
 */
const CPAppLoader: React.FC<CPAppLoaderProps> = ({ isLoading, text }) => {
  return isLoading ? (
    <Container className="cp-app-loader">
      <Box className="loader-overlay"></Box>
      <Box className="loader-spinner">
        <CPText
          style={{ marginBottom: 50 }}
          textStyle={"h3"}
          transform="uppercase"
          align="center"
        >
          {text ?? "Loading..."}
        </CPText>

        <Loader type={"infinite-spinner"} size="large" />
      </Box>
    </Container>
  ) : null;
};

export default CPAppLoader;
